import React from "react"
import { useMainEnterpriseId } from "../../hooks/enterprise"
import { useShopPaymentPointFindAllForSalePointID } from "../../hooks/shopPaymentPoint"
import ShopPaymentPointSelect from "../ShopPaymentPoint/ShopPaymentPointSelect"

interface Props {
  value?: string
  handleChange: any
  shopSalePointId: string
}

export default function OrderSelectShopPaymentPointToViewList({
  value,
  handleChange,
  shopSalePointId,
}: Props) {
  const enterpriseId = useMainEnterpriseId()

  const { shopPaymentPoints, isError, isLoading } =
    useShopPaymentPointFindAllForSalePointID(enterpriseId, shopSalePointId)

  if (isLoading) {
    return <p>Загрузка...</p>
  }

  if (isError) {
    return <p>Ошибка: {isError}</p>
  }

  return (
    <ShopPaymentPointSelect
      shopPaymentPoints={shopPaymentPoints}
      selected={value}
      handleChange={handleChange}
    />
  )
}
